
import React, { useContext, useEffect, useState } from "react";
import { IAppExtensionPage, ServiceContext } from "@msx/platform-services";
import { Routes } from "./App.routes";
import { Shell } from "../core/components/shell/Shell";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import ErrorBoundary from "../errorHandling/errorBoundry";
import { V2_Shell } from "../core/components/shell/V2Component_Shell/V2_Shell";
import PrivateRoute from "../core/components/auth/PrivateRoute";
import { getConsumptionAPI, getConsumptionAPILocal } from "./utils/httpUtils";
import { BusyIndicator } from "../core/components";
import V2_StartUp from "./components/V2_StartUp";
import { parse } from "path";
import "./App.css";
import background from "./background.svg";
import { SessionExpirationNotification, SessionTimeoutProvider } from "./components/SessionExpiration";
import { initializeFeatureFlags } from "./services/FeatureFlagService";
export interface Props { }

export const App: React.FC<Props> = () => {
  const renderRoutes = (extensonPages: IAppExtensionPage[]) => {
    return <Routes extensonPages={extensonPages} />;
  };

  const context = useContext(ServiceContext);
  const { authClient } = useContext(ServiceContext);
  const [data, setData] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch profile settings once the user is authenticated
  // const fetchProfileSetting = async () => {
  //   try {
  //     if (context) {


  //      const response = await getConsumptionAPI(`/api/V2_User/GetProfileSetting`, context.authClient);
  //           if (response.status === 200) {
  //             setData(true);
  //             sessionStorage.setItem("profilesetting","true");
  //             //setData(false);
  //             setApiCalled(true);
  //           } else {
  //             throw new Error("Failed to fetch profile settings.");
  //           }


  //   }
  //   } catch (error) {
  //     console.error("Error fetching profile settings:", error);
  //   }
  // };

  // Initialize feature flags before rendering surfaces that consume them.
  useEffect(() => {
    let isMounted = true;

    const loadFeatureFlags = async () => {
      if (!context) {
        return;
      }

      try {
        await initializeFeatureFlags(context);
      } catch (error) {
        console.error('Failed to initialize feature flags:', error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadFeatureFlags();

    return () => {
      isMounted = false;
    };
  }, [context]);

  // Trigger the profile fetch if the user is logged in
  useEffect(() => {
    let profilesetting = sessionStorage.getItem("profilesetting");

    if (profilesetting === null) {
      sessionStorage.setItem("profilesetting", "true");
    }
    else {
      const profilestatus = profilesetting === "false" ? false : true;
      setData(profilestatus);
      setApiCalled(true);
    }
  }, []);

  const renderMain = () => {
    if (loading) {
      return <BusyIndicator message="Loading..." />;
    }

    // Show V2_StartUp for login and auth flow
    // if (!isUserLoggedIn) {
    //   return <V2_StartUp setIsUserLoggedIn={setIsUserLoggedIn} />;
    // }

    // Render shell once logged in and API data is fetched
    return (
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',  // Make sure the image covers the entire div
          backgroundPosition: 'center',  // Center the image
          height: '100vh',  // Set height to 100% of the viewport height
        }}
      >
        <ErrorBoundary>
          <Router>
            <Switch>
              <PrivateRoute
                path="/"
                role="BasicAccess"
                render={(props: any) => <V2_Shell onRenderRoutes={renderRoutes} {...props} />}
              />
            </Switch>
          </Router>
        </ErrorBoundary>
      </div>
    );
  };

  // Generated by Copilot
  // updated on: 2026-08-26 | 18 lines updated | [Auto Generated] | Waited for feature flags before rendering flag-dependent UI | Time Taken 15 min

  return (
    <>
      <SessionExpirationNotification />
      <SessionTimeoutProvider>
        {renderMain()}
      </SessionTimeoutProvider>
    </>
  );
};
